import { Input, Popover, Select, Option } from 'element-ui';

export default {
    name: 'TextAnswer',
    props: {
        id: [Number, String],
        value: Array,
        label: String,
        label_class: { type: String, default: '' },
    },
    components: {
        [Input.name]: Input,
        [Select.name]: Select,
        [Popover.name]: Popover,
        [Option.name]: Option
    },
    computed: {
        column_class() {
            return `col-12`
        },
        label_class_value() {
            return `${this.label_class} float-left`
        }
    },
    data() {
        return {
        };
    },
    methods: {
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
        load() {
            
        }
    },
    mounted() {
        this.remove_tab_index();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/text-list/text-list.js